import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withScope } from '@sentry/browser';
import captureException from '../../utils/captureException';

class ErrorBoundary extends Component {
  static getDerivedStateFromError() {
    return { hasError: true };
  }

  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  componentDidCatch(error, info) {
    const { body } = document;
    this.setState({ error, hasError: true });
    withScope(scope => {
      scope.setExtras(info);
      scope.setExtra('window', {
        height: window.innerHeight,
        width: window.innerWidth,
      });
      scope.setExtra('body', {
        height: body.clientHeight,
        width: body.clientWidth,
      });
      captureException(error);
    });
  }

  render() {
    // TODO: add a Sentry report feedback dialog
    const { error, hasError } = this.state;
    const { children, ErrorComponent } = this.props;
    // Only render the reporter in dev
    return hasError
      ? <ErrorComponent error={error} />
      : children;
  }
}

ErrorBoundary.propTypes = {
  ErrorComponent: PropTypes.func,
  children: PropTypes.node,
};

export const withErrorBoundary = ErrorComponent => WrappedComponent => props => (
  <ErrorBoundary
    ErrorComponent={ErrorComponent}
  >
    <WrappedComponent {...props} />
  </ErrorBoundary>
);

export default ErrorBoundary;
